module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.d47f00ba.woff";